export default [
  {
    path: '/login/painel-contrato/visualizar/:propostaId',
    redirect: to => ({
      path: '/painel-contratos',
      query: { propostaId: to.params.propostaId },
    }),
  },
  {
    path: '/painel-contrato/visualizar/:propostaId',
    redirect: to => ({
      path: '/painel-contratos',
      query: { propostaId: to.params.propostaId },
    }),
  },
  {
    path: '/painel-contratos',
    name: 'painel-contratos',
    component: () => import('@/app-modulo/comercial/contrato/PainelContrato.vue'),
    meta: {
      resource: 'painelproposta',
      action: 'read',
      navActiveLink: 'painel-contratos',
      pageTitle: 'Painel de Contratos',
      breadcrumb: [],
    },
  },
]
